import { HEADING_STYLES as e } from "../../constants/default-styles.mjs";
import { convertStyleObjectToCss as t } from "../../utils/style-helpers.mjs";
import "./text-level-enum.mjs";
import "./utils/text-level.mjs";
import { useHeadingExtensionToolbar as n } from "./use-heading-extension-toolbar.mjs";
import { mergeAttributes as r } from "@tiptap/react";
import { Heading as i } from "@tiptap/extension-heading";
//#region src/extensions/heading-extension/index.ts
var a = i.extend({ renderHTML({ node: n, HTMLAttributes: i }) {
	let a = [
		2,
		3,
		4
	].includes(n.attrs.level) ? n.attrs.level : 2;
	return [
		`h${a}`,
		r({
			dir: "auto",
			style: t(e[a] ?? {})
		}, i),
		0
	];
} });
//#endregion
export { a as HeadingExtension, n as useHeadingExtensionToolbar };
